import { PlanDataWithMetadata } from 'api/client';
import { migratePlan } from 'api/migration/PlanMigrator';
import Alert, { IconTypeEnum } from 'components/alert';
import PlanStatusCard from 'components/plan-status-card';
import React, { FC } from 'react';
import { useStore } from 'store';
import { getPlanLink, getPlanTitle } from 'utils/helpers';
import APP_ROUTES from 'utils/routes';
import { PlanTitle, Wrapper } from './plan-status.styles';

interface Props {
  planData: PlanDataWithMetadata;
}

const PlanStatus: FC<Props> = ({ planData }) => {
  const planLink = getPlanLink(planData?.plan.type)?.summary || '';

  const [set] = useStore((state) => [state.set]);

  const migratedPlan = migratePlan(planData.plan);
  const draft =
    migratedPlan.type === 'migrated' ? migratedPlan.plan : planData.plan;

  const switchPlan = (planData: PlanDataWithMetadata) => {
    set(({ plan }) => {
      plan.draft = draft;
      plan.planId = planData.id;
    }, 'set');
  };

  return (
    <Wrapper>
      {!planData && (
        <>
          <Alert
            iconType={IconTypeEnum.Alert}
            iconPosition='center'
            href={APP_ROUTES.home}
            static
          >
            You don't have a plan yet. <br />
            <strong>Create your bushfire plan now.</strong>
          </Alert>
        </>
      )}
      {draft.completed ? (
        <PlanStatusCard
          planName={planData.plan.name || ''}
          href={planLink}
          planType={planData.plan.type}
          address={`${planData.plan.location?.suburb}, ${planData.plan.location?.postcode}`}
          handleClick={() => switchPlan(planData)}
        />
      ) : (
        <Alert
          iconType={IconTypeEnum.Alert}
          iconPosition='center'
          href={planLink}
          static
          onClick={() => switchPlan(planData)}
        >
          <PlanTitle>
            {planData.plan.name || getPlanTitle(planData.plan.type)}
          </PlanTitle>
          Your {getPlanTitle(planData?.plan.type)} is almost complete. <br />
          <strong>Finish it now.</strong>
        </Alert>
      )}
    </Wrapper>
  );
};

export default PlanStatus;
